export default __webpack_public_path__ + "static/media/new-app-logo.8364a25f.png";